import { AppBskyRichtextFacet, RichText as AtpRichText, type RichTextSegment } from '@atproto/api';

interface Facet {
  index: {
    byteStart: number;
    byteEnd: number;
  };
  features: Array<
    | { $type: 'app.bsky.richtext.facet#link'; uri: string }
    | { $type: 'app.bsky.richtext.facet#mention'; did: string }
    | { $type: 'app.bsky.richtext.facet#tag'; tag: string }
  >;
}

interface RichTextProps {
  content: string;
  facets?: Facet[];
}

export function RichText({ content, facets }: RichTextProps) {
  if (!facets || facets.length === 0) {
    return <div className='break-words whitespace-pre-wrap'>{content}</div>;
  }

  // Use official @atproto/api RichText class for robust facet handling
  const rt = new AtpRichText({ text: content, facets: facets as AppBskyRichtextFacet.Main[] });

  return (
    <div className='break-words whitespace-pre-wrap'>
      {Array.from(rt.segments()).map((segment: RichTextSegment, i: number) => {
        if (segment.isLink()) {
          return (
            <a
              key={i}
              href={segment.link!.uri}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300'
            >
              {segment.text}
            </a>
          );
        }
        if (segment.isMention()) {
          return (
            <a
              key={i}
              href={`https://bsky.app/profile/${segment.mention!.did}`}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300'
            >
              {segment.text}
            </a>
          );
        }
        if (segment.isTag()) {
          return (
            <a
              key={i}
              href={`https://bsky.app/hashtag/${encodeURIComponent(segment.tag!.tag)}`}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300'
            >
              {segment.text}
            </a>
          );
        }
        return <span key={i}>{segment.text}</span>;
      })}
    </div>
  );
}
